// Schedule's things as RowList rows (BL-189 consolidation): what each row says, in words, with no drawing
// of its own. Team manager › Time off's Company holidays.
import type { Row } from '../components/RowList/RowList.tsx';

export interface HolidayRow {
  /** "Thu, Dec 25" */
  day: string;
  /** "Christmas Day" */
  name: string;
  paid: boolean;
}

/** A coming holiday: the day, then its name, whether it's paid, and that nobody is booked on it. */
export const holidayRows = (items: readonly HolidayRow[]): Row[] =>
  items.map((h) => ({
    id: `${h.day}-${h.name}`,
    name: h.day,
    lines: [{ text: `${h.name}${h.paid ? '' : ', unpaid'}. Nobody is booked.` }],
  }));
